import { z } from 'zod';
export const MOTIFS_PUBLICS_ANNULATION = [
    'erreur_materielle',
    'remplace',
    'oeuvre_contestee',
    'autre',
];
export const annulationCertificatSchema = z.strictObject({
    motif: z.string().trim().min(5).max(300),
    motifPublic: z.enum(MOTIFS_PUBLICS_ANNULATION),
});
export function adresseVerification(slug, suffixe, jeton) {
    return `https://${slug}.${suffixe}/verifier/${jeton}`;
}
//# sourceMappingURL=certificats.js.map